import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoursesCategoriesSidebarComponent } from './app-sidebar.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { SettingsSidebarModule } from '@shared/settings-sidebar/settings-sidebar.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TrainingStatusModule } from '@shared/training-status/training-status.module';
import { StatusTextModule } from '@shared/status-text/status-text.module';

@NgModule({
  declarations: [CoursesCategoriesSidebarComponent],
  exports: [CoursesCategoriesSidebarComponent],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    TranslateModule,
    MatBadgeModule,
    MatDividerModule,
    SettingsSidebarModule,
    MatIconModule,
    TrainingStatusModule,
    StatusTextModule,
  ],
})
export class AppSidebarModule {}
